module.exports = __webpack_public_path__ + "media/images/flags/ls-636e15aeb3bfb120ac2a980fc7250770.svg";